import './_animated-icons.js';
import './_archives.js';
import './_components.js';
import './_footer.js';
import './_ideas.js';
import './_marquee.js';
import './_menu.js';
import './_people.js';
import './_popups.js';
import './_posts.js';
import './_rh-auth.js';
import './_scroll.js';
import './_subscribe.js';
import './_tables.js';
import './_tabs.js';
import './_tooltips.js';
import './_typed.js';
import './jobs-hub/_job-titles.js';
import './jobs-hub/_letters.js';
import './jobs-hub/_locations.js';
import './jobs-hub/_jobs-app.js';
import './jobs-hub/_jobs-search-form.js';
import './jobs-hub/_nav.js';

(function () {
	// Remove the 'no-js' <body> class
	document.body.classList.remove(`no-js`);
})();
